// extracted by mini-css-extract-plugin
export default {"overlay":"Overlay_style__overlay___d5","visible":"Overlay_style__visible___e0"};